import { IWebhookEndpoint } from '../../../../networked-shared-interfaces/community-admin/external-vendor-webhooks';

/** null when nothing is selected (the endpoint receives nothing), else counts. */
export const summarizeEvents = (e: Pick<IWebhookEndpoint, 'subscribedEvents' | 'subscribedGroups'>) => {
	const groups = e.subscribedGroups?.length ?? 0;
	const events = e.subscribedEvents?.length ?? 0;
	return groups || events ? { groups, events } : null;
};

export const formatTime = (ms?: number | null) => (ms ? new Date(ms).toLocaleString() : '—');

const STATUS_LABELS: Record<string, string> = {
	pending: 'Pending', delivered: 'Delivered', failed: 'Failed', held: 'Held', expired: 'Expired', skipped: 'Skipped',
};
const DISABLED_REASONS: Record<string, string> = {
	gone: 'Endpoint returned 410 Gone', failures: 'Failing for 3 days', admin: 'Disabled by an admin',
};
export const deliveryStatusLabel = (s: string) => STATUS_LABELS[s] ?? s;
export const disabledReasonLabel = (r: string) => DISABLED_REASONS[r] ?? r;

export const testResultLine = (r: { status: string; httpStatus?: number | null; durationMs?: number | null; error?: string | null }) =>
	[deliveryStatusLabel(r.status), r.httpStatus ? `HTTP ${r.httpStatus}` : null, r.durationMs != null ? `${r.durationMs} ms` : null, r.error || null]
		.filter(Boolean)
		.join(' · ');

export const toggle = <T,>(list: T[], v: T) => (list.includes(v) ? list.filter((x) => x !== v) : [...list, v]);
